/**
 * HL-11359: when Payment Element hides billing country (`fields...country: 'never'`),
 * Stripe still requires country on createConfirmationToken. The order address is the source;
 * the funnel route country is the fallback so a missing address row can never block payment.
 */
export const buildStripeConfirmationTokenParams = ({
  hideBillingCountry,
  countryId,
  fallbackCountry,
}: {
  hideBillingCountry?: boolean;
  countryId?: string | null;
  fallbackCountry?: string | null;
}): {
  params?: {
    payment_method_data: {
      billing_details: {
        address: { country: string };
      };
    };
  };
} => {
  if (!hideBillingCountry) return {};
  const country = ((countryId ?? "").trim() || (fallbackCountry ?? "").trim()).toUpperCase();
  if (!country) return {};
  return {
    params: {
      payment_method_data: {
        billing_details: {
          address: { country },
        },
      },
    },
  };
};
